import { Box, CircularProgress } from "@mui/material";
import { HamburgerMenu } from "../../../../common/components/HamburgerMenu";
import { Pricing } from "../../pricingListSlice";
import {
	STATUS_CAN_EXPORT_BOOKING_INPUT,
	STATUS_CANNOT_EXPORT_INPUT,
	STATUS_CANNOT_EXPORT_RESULT,
} from "../../pricingList.constant";
import { HamburgerOptions } from "../../../../common/components/HamburgerOptions";
import { formatError } from "../../../../common/utils/formatError";
import { useMemo } from "react";

export interface PricingHamburgerProps {
	pricing: Pricing;
	isExportLoading: boolean;
	onExportRunToExcel: () => void;
	onExportRunToJson: () => void;
	onExportRunPbParams: () => void;
	onExportBookingToJson: () => void;
}

const EMPTY_ARRAY: any[] = [];

export const PricingHamburger = (props: PricingHamburgerProps) => {
	const {
		pricing,
		onExportRunToExcel,
		onExportRunToJson,
		onExportRunPbParams,
		onExportBookingToJson,
		isExportLoading,
	} = props;

	const printAction = useMemo(() => {
		const pricingRun = pricing?.pricing_runs[0];
		const actions = [];
		if (!isExportLoading) {
			if (!STATUS_CANNOT_EXPORT_RESULT.includes(pricingRun?.status)) {
				actions.push(
					<HamburgerOptions
						key={"export"}
						title={"Export to excel"}
						action={onExportRunToExcel}
					/>
				);
			}

			if (!STATUS_CANNOT_EXPORT_INPUT.includes(pricingRun?.status)) {
				actions.push(
					<HamburgerOptions
						key={"export_JSON"}
						title={"Export JSON"}
						action={onExportRunToJson}
					/>
				);
			}

			if (pricingRun?.input_params_s3_filename) {
				actions.push(
					<HamburgerOptions
						key={"export_pb_params"}
						title={"Export powerbridge params"}
						action={onExportRunPbParams}
					/>
				);
			}

			if (STATUS_CAN_EXPORT_BOOKING_INPUT.includes(pricingRun?.status)) {
				actions.push(
					<HamburgerOptions
						key={"export_booking_inputs_json"}
						title={"Export booking inputs json"}
						action={onExportBookingToJson}
					/>
				);
			}
		}
		return actions;
	}, [pricing?.pricing_runs[0], onExportRunToExcel, onExportRunToJson]);

	const loader = useMemo(
		() =>
			isExportLoading
				? [
						<Box
							key={"loader"}
							sx={{
								display: "flex",
							}}
						>
							<CircularProgress size={20} />
						</Box>,
				  ]
				: EMPTY_ARRAY,
		[isExportLoading]
	);

	const mailToAction = useMemo(() => {
		if (pricing?.pricing_runs?.[0]?.is_pb_error) {
			const runId = pricing?.pricing_runs[0]?.id;
			const error = pricing?.pricing_runs?.[0]?.error;
			let link = "mailto:powertrading-ispowerfeatureteam.gem@engie.com?";
			link +=
				"subject=" + encodeURIComponent(`Error from gepo [${runId}]`);
			link +=
				"&body=" +
				encodeURIComponent(
					`We received an error from powerbridge when running pricing run with id ${runId}: \n\n` +
						formatError(error)
				);
			return [
				<HamburgerOptions
					key={"report-pb-error"}
					title="Report error to powebridge"
					action={() => window.open(link)}
				/>,
			];
		}
		return EMPTY_ARRAY;
	}, []);

	const RenderedChildren = useMemo(
		() => [...printAction, ...loader, ...mailToAction],
		[printAction, loader, mailToAction]
	);

	return RenderedChildren.length > 0 ? (
		<HamburgerMenu>{RenderedChildren}</HamburgerMenu>
	) : (
		<></>
	);
};
